export * from 'store/bolt/trackingV2';
import { fire, getVariables } from 'store/bolt/trackingV2';
import Store from 'store/store';

Store.on('SUBMIT_SALESFORCE_FORM', () => fire('insider-form-submit', getVariables()));
